import React, { useState, useEffect } from "react";
import { Button, Checkbox, Col, Modal, Form, Radio, Row, Space, Typography, Upload, UploadFile, message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import PdfView from "./pdvViewNew";
import { PopupConfirm } from "../../atoms/Popup";
import { generateDocumentService } from "../../modules/BookingForm/ducks/services";
import { getBookingDetail } from "../../modules/BookingForm/ducks/actions";
import { generateSettlementReport } from "../../modules/TerminationProcess/ducks/services";
import Empty from "../../../assets/svg/bookingform/empty";
import { FileDoneOutlined } from "@ant-design/icons";
import SendForSignature from "./DocuSign/SendForSignature";

const PdfCascadeView = (props) => {
  const {
    onSubmit,
    signBy,
    downloadUrl,
    documentType,
    placeholder,
    sendForEsignature,
    documentSent,
    documentName,
    setModalWidth,
    setCustomTitle,
    setSendForSignature,
    sendForSignature,
    signVia,
  } = props;

  const { bookingDetails } = useSelector((state: any) => state.newBooking);

  const sentDocs = bookingDetails?.docuSign || [];
  let docType = documentType === "bookingForm" ? "BOOKING_FORM_INST" : "TENANCY_CONTRACT";

  const {
    control,
    // set,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();

  const [pdfData, setPdfData] = useState(null);

  const [pdfFile, setPdfFile] = useState<UploadFile[]>([]);
  const [previewFile, setPreviewFile] = useState(null);

  const [openFileView, setOpenFileView] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const { leaseId = "" } = useParams();
  const normalizedSignVia = typeof signVia === "string" && signVia === "" ? null : signVia;

  const { Title } = Typography;

  const dispatch: any = useDispatch();

  const submitForm = (values) => {
    let payload = {};
    const file = pdfFile[0];
    // console.log("FILE", file);
    const checks = values?.signedByCheck ?? [];

    if (file?.originFileObj) payload["file"] = file?.originFileObj;
    // landlord / tenant / both
    if (checks && checks?.length > 0) {
      if (checks.includes(3) && checks.includes(2)) payload["signBy"] = "both";
      else if (checks.includes(3)) payload["signBy"] = "landlord";
      else if (checks.includes(2)) payload["signBy"] = "tenant";
      else payload["signBy"] = "unSigned";
      // message.error("Document is unsigned");
    }
    if (payload["signBy"]) {
      message.loading("Saving document");
      onSubmit(payload);
    }
  };

  const setSignBychecks = () => {
    if (signBy && signBy === "both") setValue("signedByCheck", [2, 3]);
    else if (signBy && signBy === "landlord") setValue("signedByCheck", [3]);
    else if (signBy && signBy === "tenant") setValue("signedByCheck", [2]);
    else if (signBy && signBy === "unsigned") setValue("signedByCheck", [1]);
  };

  useEffect(() => {
    getFile();
    setSignBychecks();
  }, [props?.pdf]);

  const getFile = async () => {
    setPdfData(props?.pdf);
  };

  const setPreviewUrl = (file) => {
    if (file?.originFileObj) {
      let url = URL.createObjectURL(file.originFileObj);
      setPreviewFile(url);
    }
  };

  useEffect(() => {
    if (pdfFile && pdfFile?.length > 0) setPreviewUrl(pdfFile[0]);
  }, [pdfFile]);

  const fileProps = {
    className: "file-upload",
    name: "file",
    accept: ".pdf",
    multiple: false,
    fileList: pdfFile?.length > 0 ? pdfFile : [],
    onChange(info) {
      const { status } = info.file;
      const { fileList } = info;
      if (fileList && fileList?.length > 0) {
        setPdfFile([fileList[0]]);
      }
      if (status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (status === "done") {
        message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === "error") {
        message.error(`${info.file.name} Please upload pdf file`);
      }
    },
    onRemove: () => {
      setPdfFile(null);
    },
    beforeUpload: (file) => {
      setPdfFile([file]);
      return false;
    },
    pdfFile,
  };

  const refreshDocs = async (data: object = null) => {
    PopupConfirm({
      title: `This will refresh the document with updated data`,
      okText: "Yes",
      onOk: async () => {
        try {
          let res: any = "";

          if (data) {
            res = await generateDocumentService(data);
          } else {
            res = await generateSettlementReport(leaseId);
          }

          if (res.data?.code === 200 || res?.code === 200) {
            res?.code === 200 && !data
              ? dispatch(getBookingDetail(leaseId + `?moveout=yes`))
              : dispatch(getBookingDetail(leaseId));
            message.success(res.data?.message || res?.message);
          }
        } catch (error) {
          setIsLoading(false);
          console.log(error);
        }
      },
    });
  };

  const filterUnsighendDocs = (isDownload = null) => {
    let tenancyContrats = bookingDetails?.ejari?.ejariDocuments ? bookingDetails?.ejari?.ejariDocuments : [];
    let contracts = [...bookingDetails?.documents, ...tenancyContrats];

    let unsignedDocs = contracts?.find((doc) => {
      if (
        doc?.documentName?.toLowerCase().includes(documentName?.toLowerCase()) &&
        doc?.documentName?.toLowerCase().includes("unsigned")
      ) {
        return doc;
      } else if (doc?.documentName === "unSignedEjariContract") {
        return doc;
      }
    });

    unsignedDocs?.documentId && isDownload && downloadUrl(unsignedDocs?.documentId);

    return unsignedDocs?.documentId;
  };

  const sendForSign = () => {
    setCustomTitle("Send for Signature");
    setModalWidth(700);
    setSendForSignature(true);
  };

  return (
    <>
      {sendForSignature ? (
        <SendForSignature
          documentName={documentName}
          setSendForSignature={setSendForSignature}
          setModalWidth={setModalWidth}
          setCustomTitle={setCustomTitle}
        />
      ) : (
        <>
          <PdfView
            previewFile={previewFile}
            pdfData={pdfData}
            openFileView={openFileView}
            setOpenFileView={setOpenFileView}
          />

          {previewFile || pdfData ? (
            <Form
              // layout="vertical"
              name="documentTemplateForm"
              onFinish={handleSubmit(submitForm)}
              scrollToFirstError
            >
              <Row gutter={[16, 16]}>
                <Col span={documentName != "settlmentReport" ? 16 : 24}>
                  {!previewFile && pdfData && (
                    <div style={{ border: "2px solid" }}>
                      <embed
                        id="myvideo"
                        src={pdfData && pdfData + "#toolbar=0&navpanes=0&scrollbar=0"}
                        title=""
                        width="100%"
                        height="330px"
                      />
                    </div>
                  )}
                  {previewFile && (
                    <div style={{ border: "2px solid" }}>
                      <object
                        id="myvideo"
                        data={previewFile + "#toolbar=0&navpanes=0&scrollbar=0"}
                        title=""
                        width="100%"
                        height="330px"
                      />
                    </div>
                  )}

                  <Row>
                    <Col
                      style={{
                        display: "flex",
                        marginTop: "10px",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <Button type="link" onClick={() => setOpenFileView(true)}>
                        View
                      </Button>
                      {filterUnsighendDocs(false) && (
                        <Button type="link" onClick={() => filterUnsighendDocs(true)}>
                          Download Original
                        </Button>
                      )}
                      {!previewFile && pdfData && (
                        <Button type="link" onClick={() => downloadUrl()}>
                          Download
                        </Button>
                        // href={pdfData} target="_blank"
                      )}
                      {documentName != "settlmentReport" && (
                        <Upload {...fileProps} style={{ position: "relative", zIndex: 99999 }}>
                          <Button type="link" className="p-0 ag-primary">
                            Upload
                          </Button>
                        </Upload>
                      )}

                      {documentName === "settlmentReport" && (
                        <Button disabled={isLoading} type="primary" className="btn-blue" onClick={() => refreshDocs()}>
                          {isLoading ? "Loading..." : "Refresh Document"}
                        </Button>
                      )}
                    </Col>
                  </Row>
                </Col>

                {placeholder && documentName !== "settlmentReport" && (
                  <Col
                    span={8}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      marginTop: "10px",
                      gap: "50px",
                      // justifyContent: "center",
                      // alignItems: "center",
                    }}
                  >
                    {signBy && signBy === "tenant" && documentName === "LTV_tenantSignedEjariContract" && (
                      <div>
                        <Button
                          icon={<FileDoneOutlined />}
                          disabled={isLoading}
                          type="primary"
                          className="docu-sign-btn-blue"
                          onClick={() => sendForSign()}
                          block
                        >
                          {sentDocs?.length > 0 ? "Resend to Landlord for Signature" : "Send to Landlord for Signature"}
                        </Button>
                      </div>
                    )}
                    {/* onChange={onChange} value={value} */}

                    <div>
                      <Title level={5}>Select document type </Title>

                      {/* TODO: //can be refactored */}
                      <Form.Item
                        required={true}
                        style={{ marginBottom: "0px" }}
                        validateStatus={errors.signedByCheck ? "error" : ""}
                        help={errors.signedByCheck && <>{errors?.signedByCheck?.message}</>}
                      >
                        <Controller
                          name={"signedByCheck"}
                          control={control}
                          rules={{ required: "Please select type" }}
                          render={({ field: { onChange, onBlur, value, ref } }) => (
                            <Checkbox.Group
                              value={value}
                              ref={ref}
                              onChange={(e) => {
                                onChange(e);
                                props.onChange && props.onChange(e);
                              }}
                            >
                              <Space direction="vertical">
                                <Checkbox value={1} disabled={value?.includes(3) || value?.includes(2)}>
                                  Unsigned
                                </Checkbox>
                                <Checkbox value={2} disabled={value?.includes(1)}>
                                  Signed by tenant
                                </Checkbox>
                                <Checkbox value={3} disabled={value?.includes(1)}>
                                  Signed by landlord{" "}
                                  {normalizedSignVia && (
                                    <span style={{ color: "rgb(0, 102, 232)" }} className="text-primary">
                                      via {normalizedSignVia}
                                    </span>
                                  )}
                                </Checkbox>
                              </Space>
                            </Checkbox.Group>
                          )}
                        />
                      </Form.Item>

                      <Row
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginTop: "0px",
                          justifyContent: "center",
                          // alignItems: "center",
                        }}
                      >
                        <Col>
                          {signBy == "unsigned" && (
                            <Button
                              type="primary"
                              className="docu-sign-btn-blue"
                              onClick={() => sendForEsignature()}
                              // disabled={disableAll}
                            >
                              {documentSent == true ? "Re-send" : "Send"} For eSignature
                            </Button>
                          )}
                        </Col>

                        <Col>
                          {signBy == "unsigned" && (
                            <Button
                              disabled={isLoading}
                              type="primary"
                              className="docu-sign-btn-blue"
                              onClick={() =>
                                refreshDocs({
                                  leaseId,
                                  document: docType,
                                  regenerate: true,
                                })
                              }
                            >
                              {isLoading ? "Loading..." : "Refresh Document"}
                            </Button>
                          )}
                        </Col>
                        <Col>
                          <Button
                            // size="small"
                            type="primary"
                            className="docu-sign-btn-green"
                            htmlType="submit"
                          >
                            Save
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                )}
              </Row>
            </Form>
          ) : (
            <Row style={{ justifyContent: "center" }}>
              <Empty width="200px" height="200px" style={{ alignContent: "center" }} />
            </Row>
          )}
        </>
      )}
    </>
  );
};
export default PdfCascadeView;
